import type { ReactElement } from 'react';
import { databaseHealthFacts, type SystemMonitorCard } from '../lib/systems-monitor';

/** Read-only database health. A missing figure stays Unknown; the note says why. */
export function DatabaseHealthStrip({ card }: { readonly card: SystemMonitorCard | null }): ReactElement {
  const facts = databaseHealthFacts(card);
  return (
    <section className="database-health" aria-label="Database health">
      <header className="row spread">
        <h2>Database</h2>
      </header>
      <dl>
        {facts.map((fact) => (
          <div key={fact.id}>
            <dt>{fact.label}</dt>
            <dd>
              {fact.value}
              {fact.detail ? <small className="muted">{fact.detail}</small> : null}
            </dd>
          </div>
        ))}
      </dl>
      <p className="muted">{card?.source ?? 'No Supabase connector evidence.'}</p>
    </section>
  );
}
